var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-box"},_vm._l((_vm.pageTotalNum),function(index){return _c('PDF',{key:index,ref:"pdf",refInFor:true,attrs:{"src":_vm.pdfUrl,"page":index}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }